import { Button, InputNumber, Modal, notification } from 'antd'
import { debounce, isNumber } from 'lodash'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { GiaMinMax, getBankTransferContent, typeFund } from 'src/helpers/constants'
import { formatCurrency } from 'src/helpers/functions'
import { useStore } from 'src/hooks'
import { ROUTER_PATH } from 'src/screens/routes/metaData'
import { PENDING_PAYMENT_KEY } from 'src/screens/payment'

type TopupModalProps = {
   isTopupModalOpen: boolean
   handleCancel: () => void
}

const TopupModal: React.FC<TopupModalProps> = ({ isTopupModalOpen, handleCancel }) => {
   const FundStore = useStore('FundStore')
   const AuthStore = useStore('AuthStore')
   const CommonConfigStore = useStore('CommonConfigStore')
   const history = useHistory()
   const [amount, setAmount] = useState<any>(null)
   const { t } = useTranslation()

   const handleChangeAmount = (value: any) => {
      setAmount(value)
   }

   const onClose = () => {
      setAmount(null)
      handleCancel()
   }

   // Số tiền không hợp lệ (chưa nhập / nhỏ hơn mức tối thiểu)
   const invalidAmount =
      !amount ||
      !isNumber(amount) ||
      (CommonConfigStore?.designerConfigList?.minRecharge &&
         parseInt(amount + '') < parseInt(CommonConfigStore?.designerConfigList?.minRecharge + ''))

   const handleApplyTopup = async () => {
      if (invalidAmount) {
         notification.open({
            message: t(GLOBAL_CLIENT.thongbao),
            description: t(GLOBAL_CLIENT.errorNapTien).replace(
               '{0}',
               CommonConfigStore?.designerConfigList?.minRecharge
            )
         })
         return
      }

      const code = CommonConfigStore.bankAccount?.DESCRIPTION || ''
      const params = {
         price: amount || '',
         code,
         accountId: AuthStore?.data_getUserInfo?.id || '',
         description: t(GLOBAL_CLIENT.creatornaptien),
         type: typeFund.RECHARGE
      }

      const result = await FundStore.createFund(params)
      if (result?.code === 200) {
         // Mã giao dịch lấy từ API trả về (luồng cũ), ví dụ: ABC123
         const fundCode = result?.data?.code || code
         // Nội dung chuyển khoản dạng POD + mã, ví dụ: PODABC123
         const content = getBankTransferContent(fundCode)

         // Lưu thông tin thanh toán để màn hình thanh toán đọc lại (giữ được khi refresh)
         sessionStorage.setItem(
            PENDING_PAYMENT_KEY,
            JSON.stringify({
               amount,
               code: fundCode,
               content,
               bankAccount: CommonConfigStore.bankAccount
            })
         )
         onClose()
         history.push(`/${ROUTER_PATH.PaymentScreen}`)
      } else {
         notification.error({
            message: t(GLOBAL_CLIENT.thongbao),
            description: result?.message || 'Tạo lệnh nạp tiền thất bại'
         })
      }
   }

   return (
      <Modal
         maskClosable={false}
         closable={false}
         title={t(GLOBAL_CLIENT.deposit)}
         visible={isTopupModalOpen}
         onCancel={onClose}
         footer={null}
      >
         <div
            className="ant-upload-hint"
            style={{
               paddingTop: 12,
               paddingBottom: 12,
               fontSize: 12,
               textAlign: 'center',
               fontStyle: 'italic',
               color: invalidAmount ? 'red' : '#888'
            }}
         >
            Số tiền nạp tối thiểu là {formatCurrency(CommonConfigStore?.designerConfigList?.minRecharge, true)} đ
         </div>

         <div style={{ textAlign: 'center', marginTop: 8 }}>
            <InputNumber
               style={{ width: '100%' }}
               placeholder={t(GLOBAL_CLIENT.sotienmuonnap)}
               formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
               parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
               min={GiaMinMax.minNap}
               max={GiaMinMax.maxNap}
               step={1000}
               onChange={(value: any) => handleChangeAmount(value)}
            />
         </div>

         <div
            style={{
               width: '100%',
               marginTop: 24,
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               gap: 12
            }}
         >
            <Button type="dashed" onClick={onClose}>
               {t(GLOBAL_CLIENT.huy)}
            </Button>
            <Button type="primary" onClick={debounce(handleApplyTopup, 500)} disabled={invalidAmount}>
               {t(GLOBAL_CLIENT.xacnhancktc)}
            </Button>
         </div>
      </Modal>
   )
}

export default TopupModal
